module.exports = __webpack_public_path__ + "static/media/Zombie Cheerleader.75a4a05f.jpg";